module.exports = __webpack_public_path__ + "img/logo_TESTIN.16f02984.png";